import React from "react";

/**
 * TEMPORARILY DISABLED.
 * This component previously caused redirect loops (everything -> /me).
 * We will re-enable later once routing is stable.
 */
export default function AuthRedirector() {
  return null;
}